import { createAsyncThunk } from '@reduxjs/toolkit'
import { NotificationModel } from '../../models/Notification'
import { pushNotification } from '../application/applicationSlice'
import {
    profileRequest,
    profileUpdateRequest,
    tokenRefresh,
    tokenRequest,
    avatarUploadRequest,
} from '../../apiClient/userRequests'


const httpStatus = (err) =>
  err?.response?.status ?? err?.status ?? err?.code ?? 0;

const httpDetail = (err) =>
  err?.response?.data ?? err?.message ?? 'Unknown error';


export const loadPersistedAuthThunk = createAsyncThunk(
    'user/loadPersistedAuth',
    async () => {
        const access = localStorage.getItem('token_access');
        const refresh = localStorage.getItem('token_refresh');
        return { access, refresh };
    }
);

export const tokenRequestThunk = createAsyncThunk(
    'user/tokenRequest',
    async (loginForm, thunkAPI) => {
        try {
            const res = await tokenRequest(loginForm);
            const data = res.data;
            if (data.access) localStorage.setItem('token_access', data.access);
            if (data.refresh) localStorage.setItem('token_refresh', data.refresh);
            return thunkAPI.fulfillWithValue(data);
        } catch (err) {
            return thunkAPI.rejectWithValue({
                http_status_code: httpStatus(err),
                detail: httpDetail(err),
            });
        }
    }
);

export const tokenRefreshThunk = createAsyncThunk(
    'user/tokenRefresh',
    async (_, thunkAPI) => {
        const state = thunkAPI.getState();
        try {
            const res = await tokenRefresh({ refresh: state.user.token_refresh });
            const data = res.data;
            if (data.access) localStorage.setItem('token_access', data.access);
            if (data.refresh) localStorage.setItem('token_refresh', data.refresh);
            return thunkAPI.fulfillWithValue(data);
        } catch (err) {
            // hidrate error information on failed request
            return thunkAPI.rejectWithValue({
                http_status_code: httpStatus(err),
                detail: httpDetail(err),
            });
        }
    }
);

export const profileRequestThunk = createAsyncThunk(
    'user/profile',
    async (_, thunkAPI) => {
        try {
            const res = await profileRequest(thunkAPI);
            return thunkAPI.fulfillWithValue(res.data);
        } catch (err) {
            // hidrate error information on failed request
            return thunkAPI.rejectWithValue({
                http_status_code: httpStatus(err),
                detail: httpDetail(err),
            });
        }
    }
);
export const profileUpdateThunk = createAsyncThunk(
  'user/profile/update',
  async (payload, thunkAPI) => {
    try {
      const res = await profileUpdateRequest(thunkAPI, payload)
      return thunkAPI.fulfillWithValue(res.data)
    } catch (err) {
      thunkAPI.dispatch(
        pushNotification(
          new NotificationModel(
            'Error en la actualización',
            `HTTP error: ${httpStatus(err)}`,
            'error'
          ).toJson()
        )
      )
      return thunkAPI.rejectWithValue({
        http_status_code: httpStatus(err),
        detail: httpDetail(err),
      })
    }
  }
)
export const logoutThunk = createAsyncThunk(
    'user/logout',
    async (_, thunkAPI) => {
        try {
            localStorage.removeItem('token_access');
            localStorage.removeItem('token_refresh');
            document.cookie = `sessionid=; expires=Sat, 20 Jan 1980 12:00:00 UTC`;
            document.cookie = `csrftoken=; expires=Sat, 20 Jan 1980 12:00:00 UTC`;
            return thunkAPI.fulfillWithValue(true);
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const avatarUploadThunk = createAsyncThunk(
    'user/avatar/upload',
    async (file, thunkAPI) => {
        try {
            const res = await avatarUploadRequest(thunkAPI, file)
            return thunkAPI.fulfillWithValue(res.data)
        } catch (err) {
            thunkAPI.dispatch(
                pushNotification(
                    new NotificationModel(
                        'Error en la subida del avatar',
                        `HTTP error: ${httpStatus(err)}`,
                        'error'
                    ).toJson()
                )
            )
            return thunkAPI.rejectWithValue({
                http_status_code: httpStatus(err),
                detail: httpDetail(err),
            })
        }
    }
)